import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Button from '@react/react-spectrum/Button'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'

export default function SampleCodeButton (props) {
    const { referrer, isDisabled } = props
    const { ut, dispatch } = useContext(EasybakeContext)

    function go (e, referrer) {
        analytics.sendEventName('click', `${referrer}:accesstoken`)
        dispatch({ type: 'set-page', payload: { page: 'accesstoken' } })
    }

    function getIsDisabled() {
        if (!ut) {
            return true
        }
        if (isDisabled) {
            return true
        }
    }

    return (
        <Button 
            {...props}
            label={__('console_get_started_btn_try_sample')}
            disabled={getIsDisabled()} 
            variant="primary" 
            onClick={(e) => go(e, referrer)}
        />
    )
}
